var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14h2v-2H3v2zm3.17-6.83l.9-.92C7.64 5.68 8 4.88 8 4c0-2.21-1.79-4-4-4S0 1.79 0 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 .55-.22 1.05-.59 1.41L4.17 6.67C3.45 7.4 3 8.4 3 9.5v.5h2c0-1.5.45-2.1 1.17-2.83z",
    fill: "currentColor"
  })));
}

export default SvgHelp;